export default {
  Titulo: 'Consultar SQL',
  Campos: {
    QuerySQL: {
      Tipo: 'textarea',
      Label: 'Query SQL',
      Tooltip: 'Query SQL',
      Placeholder: 'Query SQL',
      Desabilitado: true,
      Linhas: 20
    }
  }
};
